import { render, staticRenderFns } from "./ShowError.vue?vue&type=template&id=18188090&scoped=true"
import script from "./ShowError.vue?vue&type=script&lang=js"
export * from "./ShowError.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "18188090",
  null
  ,true
)

export default component.exports